<template>
    <tr class="tr">
        <td class="td"></td>
        <td class="td" v-for="columnWithSettings in visibleColumnsWithSettings" :key="columnWithSettings.column" :class="getColumnClass(columnWithSettings)">
            {{ getColumnValueText(columnWithSettings.column, columnWithSettings.settings) }}
        </td>
    </tr>
</template>

<script>
import portfolioColumns from '@/services/portfolioColumns'

export default {
    props:{
        groupedCoinsByGeckoId: Object,
    },
    computed:{
        visibleColumnsWithSettings(){
            return portfolioColumns.visibleColumnsWithSettings
        },

        // --- Required columns ---
        totalInvested(){
            return this.getColumnSum('totalInvested')
        },
        currentWorth(){
            return this.getColumnSum('currentWorth')
        },
        totalSoldFiat(){
            return this.getColumnSum('totalSoldFiat')
        },
        totalBoughtFiat(){
            return this.getColumnSum('totalBoughtFiat')
        },
        relativeBoughtFiat(){
            return this.getColumnSum('relativeBoughtFiat')
        },
        profitFiat(){
            return this.getColumnSum('profitFiat')
        },
        profitPercentage(){
            return this.profitFiat / this.getColumnSum('relativeBoughtFiat') * 100
        },
        totalProfitFiat(){
            return this.getColumnSum('totalProfitFiat')
        },
        totalProfitPercentage(){
            return this.totalProfitFiat / this.totalBoughtFiat * 100
        },
    },
    methods:{
        getColumnValueText(column, colSettings){
            const value = this.getColumnValue(column, colSettings)
            if(value == ''){
                return ''
            }
            return `${colSettings.prefix || '' }${value}${colSettings.suffix || '' }`
        },
        getColumnValue(column, colSettings){
            if(this[column] == undefined){
                return ''
            }
            if(colSettings.decimals != undefined){
                return this[column].toFixed(colSettings.decimals)
            }
            return this[column]
        },
        getColumnClass(columnWithSettings){
            if(!columnWithSettings.settings.class){
                return ''
            }
            const value = this.getColumnValue(columnWithSettings.column, columnWithSettings.settings)
            return columnWithSettings.settings.class(value)
        },
        getColumnSum(colName){
            return Object.values(this.groupedCoinsByGeckoId).map(x => x[colName]).reduce((prevValue, curValue)=>{
                return prevValue + curValue
            }, 0)
        },
    }
}
</script>